import React from "react";

const NotFound = () => {
  return (
    <div className="my-52">
      <h1 className=" text-teal-700 text-3xl">
        <span className=" text-black font-black text-7xl">404 !</span> THE PAGE
        IS NOT FOUND{" "}
      </h1>
    </div>
  );
};

export default NotFound;
